import React, { useState, useEffect } from 'react';
import { ArrowDown } from 'lucide-react';
import WhatsAppIcon from './icons/WhatsAppIcon';
import { useCMS } from '../store/cmsStore';

export default function Hero() {
  const { data } = useCMS();
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    'https://doratalhuda.com/storage/uploads/heroes/gLt061BxMpHW1aBB6oZ4.webp',
  ];

  const scrollToPackages = () => {
    document.getElementById('packages')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative min-h-[100vh] md:min-h-[90vh] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={slides[0]}
          alt={`${data.settings.heroTitle} - رحلات عمرة مريحة إلى مكة والمدينة`}
          className="w-full h-full object-cover"
          loading="eager"
          fetchPriority="high"
          width="1920"
          height="1080"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-32 right-16 text-white/10 text-8xl font-amiri select-none">☽✦</div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6 border border-white/20">
            <span className="w-2 h-2 rounded-full bg-gold-400 animate-pulse" />
            <span className="text-white/90 font-cairo text-sm">انطلاق شبه يومي من الرياض</span>
          </div>

          {/* Title */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-amiri font-bold text-white mb-6 leading-tight">
            {data.settings.heroTitle}
            <br />
            <span className="text-gold-400">براحة تليق برحلتك</span>
          </h1>

          {/* Description */}
          <p className="text-lg md:text-xl text-white/80 font-cairo leading-relaxed mb-8 max-w-2xl">
            {data.settings.heroSubtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={`https://wa.me/${data.settings.whatsapp}?text=السلام عليكم، أريد الاستفسار عن حجز رحلة عمرة من الرياض`}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-brown-600 hover:bg-brown-700 text-white px-8 py-4 rounded-xl font-cairo font-bold text-lg flex items-center justify-center gap-3 transition-all shadow-xl hover:shadow-2xl hover:scale-105"
            >
<WhatsAppIcon className="w-6 h-6" />
              {data.settings.heroCta}
            </a>
            <button
              onClick={scrollToPackages}
              className="bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm border border-white/30 px-8 py-4 rounded-xl font-cairo font-bold text-lg flex items-center justify-center gap-3 transition-all"
            >
              استكشف الباقات
              <ArrowDown size={20} />
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1 h-2 bg-white/50 rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
}